import React, { FC, ReactElement } from 'react';
import { CountryItem } from '../data';
import CountriesListItem from './CountriesListItem';

type CountriesListProps = {
  id: string;
  region: string;
  countries: CountryItem[];
}

const CountriesList: FC<CountriesListProps> = ({ id, region, countries }: CountriesListProps): ReactElement => {
  const countriesElements = countries.map((item: CountryItem) => {
    return (
      <CountriesListItem key={item.id} name={item.name} url={item.url}/>
    );
  });

  return (
    <div className="freight-forwarder__countries-list">
        <h3 className="freight-forwarder__countries-list-title" id={id}>{region}</h3>
        <ul className="freight-forwarder__countries-list-items">
          {countriesElements}
        </ul>
    </div>
  );
};

export default CountriesList;